module.exports = __webpack_public_path__ + "static/Pink Card-a51e194d461b27ae87bd0719ecd73f55.png";